import { useEffect, useState } from "react"

export function useSessionStorage<T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const item = globalThis.sessionStorage.getItem(key)
      return item === null ? initialValue : (JSON.parse(item) as T)
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    try {
      if (value != undefined)
        globalThis.sessionStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.warn(`Error setting sessionStorage key "${key}":`, error)
    }
  }, [key, value])

  return [value, setValue]
}
